import { render, staticRenderFns } from "./AnalyticsBenchmark.vue?vue&type=template&id=63ae8fae&"
import script from "./AnalyticsBenchmark.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnalyticsBenchmark.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports